import axios from "axios";
import qs from "qs";
import functionalTool from "@/utils/functionTools";
import jsbridge from "@/utils/jsbridge";
import { uuid } from "vue-uuid";
import md5 from "js-md5";
import { Toast } from "vant";
const channel = functionalTool.getUrlParam("channel");
const appVersion = { wechat: "7.0.0.2", ali: "7.0.0.3" }[channel];
//获取签名
const getSign = async (params, time) => {
  functionalTool.deleteEmpty(params);
  const ordered = {};
  const newParams = {
    ...params,
    timestamp: time
  };
  //按名字排序
  Object.keys(newParams)
    .sort()
    .forEach(function(key) {
      ordered[key] = newParams[key];
    });
  const paramsStr = qs.stringify(ordered);
  return new Promise(resolve => {
    resolve({
      data: md5(`${md5(paramsStr)}${time}`).toUpperCase(),
      time
    });
  });
};
// 获取token
const getToken = () => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      jsbridge({
        name: "getRefreshToken",
        callBack: res => {
          if (res) {
            const url = window.location.href.split("?")[0];
            const param = window.location.href.split("?")[1];
            location.replace(`${url}?${param}&token=${res}`);
            resolve(res);
          } else {
            logOut();
          }
        }
      });
    }, 200);
  });
};
const miniProgramRequest = axios.create({
  timeout: 14e3
});

// 添加请求拦截器
miniProgramRequest.interceptors.request.use(async request => {
  const timeNum = +new Date();
  const nonce = uuid.v4();
  const Authorization = functionalTool.getUrlParam("token") || "";
  let params;
  if (request.method === "get") {
    functionalTool.deleteEmpty(request.params);
    request.params = { ...request.params, nonce };
    params = {
      ...request.params
    };
  } else if (request.method === "post") {
    const paramsStr = qs.parse(request.data);
    functionalTool.deleteEmpty(paramsStr);
    request.data = qs.stringify(paramsStr);
    params = {
      ...qs.parse(request.data)
    };
  }
  const res = await getSign(params, timeNum);
  const header = {
    "channel-id": functionalTool.getUrlParam("channelId"),
    "X-Ca-Timestamp": res.time,
    "X-Ca-Signature": res.data,
    userId: functionalTool.getUrlParam("userId") || "",
    verify: functionalTool.getUrlParam("verify") || "",
    "x-uid": functionalTool.getUrlParam("openId"),
    positCity: functionalTool.getUrlParam("cityCode"),
    appVersion,
    Authorization
  };
  request.headers = Object.assign(request.headers, header);
  return request;
});

// 添加响应拦截器
miniProgramRequest.interceptors.response.use(
  function(response) {
    // 对响应数据做点什么
    if (response.data.code === "10404") {
      // token过期，获取新token
      return getToken().then(res => {
        return miniProgramRequest.request(response.config); // 这里是核心代码，登录成功后重新请求！返回Promise对象。
      });
    }
    if (response.data.code !== "200") {
      Toast(response.data.text);
      return Promise.reject(response);
    }
    if (response.data.code === "200" && !response.data.pageLimit) {
      return response;
    } else {
      return response;
    }
  },
  function(error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default miniProgramRequest;



// WEBPACK FOOTER //
// ./src/starcharge/mock/miniprogramRequest.js